import { GET_MERGE_PARAMS_URL } from 'api/TemplateEditAPI';
import { MessageMedium } from 'constants/messageMediums';
import { RestQueryHookOptions, useRestQuery } from 'utils/hooks/api/useRestQuery';

type QueryMergeParamsResponse = string[];

export const useQueryMergeParams = (
  messageMedium: MessageMedium,
  options: RestQueryHookOptions<QueryMergeParamsResponse> = {},
) => {
  const { isLoading, error, data, refetch } = useRestQuery<QueryMergeParamsResponse>(
    GET_MERGE_PARAMS_URL,
    { messageMedium },
    { ...options, enabled: false },
  );

  return {
    isLoading,
    error,
    mergeParams: data ?? [],
    getMergeParams: () => refetch(), // TODO: Will update this to just refetch and auto `enabled` the query in the future once we localize the `DragAndDropEditorProvider` to the `DragAndDropEditor` component.
  };
};
